import pcssAdminSettings from '../src/Admin/Settings/pcss/*.pcss';

import jsAdminSettings from '../src/Admin/Settings/js/index.jsx';